import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'currencyShortHand',
  standalone: true
})
export class CurrencyShortHandPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return ''
    if (value < 1000) {
      return `$${Math.floor(value)}`
    }

    if (value < 1_000_000) {
      return `$${Math.floor(value / 1000)}k`
    }

    if (value < 1_000_000_000) {
      return `$${Math.floor(value / 100_000) / 10}M`
    }

    return `$${(value / 1_000_000_000).toFixed(1)}B`
  }
}
